<template>
<div class="chapter">
<div class="inner_page">
<a id="pviii"></a><a id="pix"></a><a id="px"></a><a id="pxi"></a>
<blockquote class="sink">
<p class="left indent3">As we destroy that which is natural we eat ourselves alive.</p>
<p class="right indent3"><em>—William Kittredge</em></p>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front03.vue?37cdcdf7